import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

import PasswordInput from '../components/PasswordInput';
import { isPasswordValid } from '../utils/password';


function csrfToken() {
    return (window.Params && window.Params.csrf_token) || '';
}


function translateError(code) {
    switch (code) {
        case 'bad-password': return 'Неверный пароль';
        case 'nickname-exists': return 'Этот никнейм уже занят';
        case 'bad-nickname': return 'Никнейм не соответствует требованиям';
        case 'already-requested': return 'Удаление уже запрошено';
        case 'not-requested': return 'Удаление не запрошено';
        case 'no-franchise': return 'Ошибка франшизы';
        case 'unauthorized': return 'Необходимо авторизоваться';
        default: return code;
    }
}


class AccountDeletionDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            busy: false,
            password: '',
            error: '',
            message: '',
            deletion: null,
            nickname: '',
            newNickname: '',
            nicknameBusy: false,
            nicknameError: '',
            nicknameMessage: '',
        };
    }

    componentDidMount() {
        this.loadStatus();
    }

    loadStatus() {
        this.setState({ loading: true });
        fetch('/franchise/auth/delete-status', {
            credentials: 'same-origin',
            headers: { 'X-CSRF-Token': csrfToken() },
        })
            .then(resp => resp.json())
            .then(json => {
                if (json.status === 'error') {
                    this.setState({ loading: false, error: json.code });
                    return;
                }
                this.setState({
                    loading: false,
                    deletion: json,
                    nickname: json.nickname || '',
                    newNickname: json.nickname || '',
                });
            })
            .catch(err => {
                this.setState({ loading: false, error: err.message });
            });
    }

    handleNicknameChange() {
        const { newNickname, password, nickname, nicknameBusy } = this.state;
        if (nicknameBusy || !newNickname || !password || newNickname === nickname) {
            return;
        }
        this.setState({ nicknameBusy: true, nicknameError: '', nicknameMessage: '' });
        fetch('/franchise/auth/update-nickname', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken(),
            },
            body: JSON.stringify({ nickname: newNickname, password }),
        })
            .then(resp => resp.json())
            .then(json => {
                if (json.status === 'error') {
                    this.setState({ nicknameBusy: false, nicknameError: json.code });
                    return;
                }
                this.setState({
                    nicknameBusy: false,
                    nickname: json.nickname,
                    newNickname: json.nickname,
                    nicknameMessage: 'Никнейм сохранён',
                });
                if (window.Params && window.Params.user) {
                    window.Params.user.name = json.nickname;
                }
            })
            .catch(err => {
                this.setState({ nicknameBusy: false, nicknameError: err.message });
            });
    }

    handleRequest() {
        this.setState({ busy: true, error: '', message: '' });
        fetch('/franchise/auth/delete-request', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken(),
            },
            body: JSON.stringify({ password: this.state.password }),
        })
            .then(resp => resp.json())
            .then(json => {
                if (json.status === 'error') {
                    this.setState({ busy: false, error: json.code });
                    return;
                }
                this.setState({ busy: false, password: '', deletion: json, message: 'Аккаунт будет удалён через 30 дней' });
            })
            .catch(err => {
                this.setState({ busy: false, error: err.message });
            });
    }

    handleCancel() {
        this.setState({ busy: true, error: '', message: '' });
        fetch('/franchise/auth/delete-cancel', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken(),
            },
            body: JSON.stringify({}),
        })
            .then(resp => resp.json())
            .then(json => {
                if (json.status === 'error') {
                    this.setState({ busy: false, error: json.code });
                    return;
                }
                this.setState({ busy: false, deletion: { deletion_pending: false }, message: 'Удаление отменено' });
                if (this.props.onCancel) {
                    this.props.onCancel();
                }
            })
            .catch(err => {
                this.setState({ busy: false, error: err.message });
            });
    }

    close() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        const { open, mode } = this.props;
        const {
            loading, busy, deletion, password, error, message,
            nickname, newNickname, nicknameBusy, nicknameError, nicknameMessage,
        } = this.state;

        const nicknameChanged = newNickname !== nickname;

        const isNickname = mode === 'nickname';
        const isDelete = mode === 'delete';

        const title = isDelete ? 'Удалить аккаунт' : (isNickname ? 'Изменить никнейм' : 'Настройки аккаунта');

        const nicknameSection = (
            <>
                <TextField
                    label="Никнейм"
                    fullWidth
                    value={newNickname}
                    disabled={nicknameBusy || (deletion && !deletion.can_change_nickname)}
                    onChange={e => this.setState({ newNickname: e.target.value })}
                    margin="normal"
                    helperText="Минимум 3 символа, буквы, цифры, _ - ( )"
                />
                <PasswordInput
                    label="Текущий пароль"
                    value={password}
                    onChange={e => this.setState({ password: e.target.value })}
                    error={password.length > 0 && !isPasswordValid(password)}
                />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.handleNicknameChange()}
                    disabled={!newNickname || !nicknameChanged || !password || nicknameBusy || !isPasswordValid(password)}
                    style={{ marginTop: 8 }}
                >
                    {nicknameBusy ? <CircularProgress size={20} /> : 'Сохранить ник'}
                </Button>
                {nicknameError && (
                    <Typography color="error" style={{ marginTop: 12 }}>
                        {translateError(nicknameError)}
                    </Typography>
                )}
                {nicknameMessage && (
                    <Typography style={{ marginTop: 12, color: '#388e3c' }}>
                        {nicknameMessage}
                    </Typography>
                )}
            </>
        );

        const renderDeleteSection = () => (
            <>
                {!deletion.deletion_pending && (
                    <PasswordInput
                        label="Текущий пароль"
                        value={password}
                        onChange={e => this.setState({ password: e.target.value })}
                        error={password.length > 0 && !isPasswordValid(password)}
                    />
                )}
                {deletion.deletion_pending && (
                    <>
                        <Typography variant="body1" gutterBottom>
                            Аккаунт запланирован к удалению.
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            Осталось дней: {deletion.days_left}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Все игры сняты с публикации. Нажмите «Отменить удаление», чтобы восстановить доступ.
                        </Typography>
                    </>
                )}
                {!deletion.deletion_pending && (
                    <>
                        <Typography variant="body1" gutterBottom>
                            После запроса аккаунт будет удалён через 30 дней. В течение этого времени вы можете отменить удаление.
                        </Typography>
                        <Typography variant="body2" color="textSecondary" gutterBottom>
                            Все игры будут сняты с публикации.
                        </Typography>
                    </>
                )}
            </>
        );

        const deleteAction = !loading && deletion && (
            deletion.deletion_pending ? (
                <Button
                    onClick={() => this.handleCancel()}
                    color="primary"
                    variant="contained"
                    disabled={busy}
                >
                    {busy ? <CircularProgress size={20} /> : 'Отменить удаление'}
                </Button>
            ) : (
                <Button
                    onClick={() => this.handleRequest()}
                    color="secondary"
                    variant="contained"
                    disabled={!password || busy || !isPasswordValid(password)}
                >
                    {busy ? <CircularProgress size={20} /> : 'Удалить аккаунт'}
                </Button>
            )
        );

        return (
            <Dialog open={open} onClose={() => this.close()} maxWidth="sm" fullWidth>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {loading && <CircularProgress />}
                    {!loading && deletion && (
                        <>
                            {isNickname && nicknameSection}
                            {isDelete && renderDeleteSection()}
                            {!isNickname && !isDelete && (
                                <>
                                    {nicknameSection}
                                    <hr style={{ margin: '24px 0', border: 0, borderTop: '1px solid #e0e0e0' }} />
                                    {renderDeleteSection()}
                                </>
                            )}
                        </>
                    )}
                    {error && (
                        <Typography color="error" style={{ marginTop: 12 }}>
                            {translateError(error)}
                        </Typography>
                    )}
                    {message && (
                        <Typography style={{ marginTop: 12, color: '#388e3c' }}>
                            {message}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.close()} disabled={busy || nicknameBusy}>
                        Закрыть
                    </Button>
                    {!isNickname && deleteAction}
                </DialogActions>
            </Dialog>
        );
    }
}

AccountDeletionDialog.defaultProps = {
    mode: 'combined'
};

export default AccountDeletionDialog;
